module.exports = __webpack_public_path__ + "static/coming-soon-35630e5cc1e4ece7261c11ef78ed90b6.svg";